import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import http from "../services/httpService";
import FilterListIcon from "@material-ui/icons/FilterList";
import { investmentDetailsPath, investmentsPath } from "../utils/varialbles";
import {
  popoverClasses,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Upd from "../images/upd.svg";
import Down from "../images/down.svg";
import CancelIcon from "@material-ui/icons/Cancel";
import NumberFormat from "react-number-format";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";
// import Portfoliofilter from './portfoliofilter';

export default function Investments() {
  const location = useLocation();

  const history = useHistory();

  const myparam = location;

  const [rows, setRows] = useState([]);

  const [popUp, setPopUp] = useState(false);

  const [close, setClose] = useState(false);

  const [data, setData] = useState();

  const [overallData, setOverallData] = useState();

  const [columns, setColumns] = useState([
    {
      label: "Country",
      id: "alpha2_code",
    },
    {
      label: "Name",
      id: "name",
      cursor: "pointer",
    },
    {
      label: "Type",
      id: "type",
    },
    {
      label: "Amount",
      id: "advisedval",
      align: "center",
    },
    {
      label: "Weightage",
      id: "adv_weightage",
      align: "center",
      type: "weight_percentage",
    },
    {
      label: "Current Value",
      id: "currentval",
      align: "center",
    },
    {
      label: "Change(%)",
      id: "gainper",
      align: "center",
      type: "percentage",
    },
    {
      label: "Amount",
      id: "invested_investedval",
      align: "center",
    },
    {
      label: "Weightage",
      id: "inv_weightage",
      align: "center",
      type: "weight_percentage",
    },
    {
      label: "Current Value",
      id: "invested_currentval",
      align: "center",
    },
    {
      label: "Change(%)",
      id: "invested_gainper",
      align: "center",
      type: "percentage",
    },
  ]);

  const [getapistring, setapistring] = useState("");
  const getDelivedState = (abc) => {
    if (!abc) {
      setapistring("");
    } else {
      setapistring(abc);
    }
  };

  var filstr = localStorage.getItem("filterstr");

  let adviceinvesturl = "";

  if (filstr) {
    adviceinvesturl = `/investments?cust_id=${myparam.state.customer_id}&${filstr}`;
  } else if (!filstr) {
    adviceinvesturl = `/investments?cust_id=${myparam.state.customer_id}&country=All&type=All&assettype=All&source=All`;
  }

  const getData = () => {
    http
      .get(adviceinvesturl)
      .then((res) => {
        setOverallData(res.data.data);
        setRows(res.data.data.myinvestments);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getData();
  }, [filstr]);

  const investmentdetailspath = (e) => {
    if (myparam && myparam.state.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam.state,
      });
    }
  };

  // (data.type);
  // (data.cummilative);

  const showCumulative = (e, rowdata) => {
    e.preventDefault();
    setPopUp(!popUp);
    setData(rowdata);
  };
  // const [mpopUp, setMPopUp]=useState(false);

  const [filter, setfilter] = useState(false);

  // const mutualpop=(e, rowDataMutual)=>{
  //   (rowDataMutual);
  //   setMPopUp(val=>!val);
  //   setMData(rowDataMutual);
  // }

  const closePop = () => {
    setClose();
    setPopUp(!popUp);
  };

  const openfilter = (e) => {
    e.preventDefault();
    setfilter((val) => !val);
  };

  return (
    <div>
      <div className="menuhead">
        <button
          className="ovrbtn"
          onClick={investmentdetailspath}
          style={{ borderBottom: "transparent" }}
        >
          Overview
        </button>
        <button
          className="ovrbtn"
          onClick={(e) => history.push(investmentsPath)}
          style={{ marginLeft: "30px" }}
        >
          Investments
        </button>

        {/* <div className="prospectsearch">
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            className={"mt30"}          
          />
        </div> */}
      </div>
      <div style={{ textAlign: "right" }}>
        <FilterListIcon
          onClick={(e) => openfilter(e)}
          style={{ cursor: "pointer" }}
        />
      </div>

      {overallData !== undefined ? (
        <div>
          <div style={{ display: "flex", columnGap: 30, flexWrap: "wrap" }}>
            <div>
              <p>Total Adviced Amount</p>
              <h4>{overallData.currency + " " + overallData.investedval}</h4>
            </div>
            <div>
              <p>Adviced Current Value</p>
              <h4>{overallData.currency + " " + overallData.currentval}</h4>
            </div>
            <div>
              <p>Adviced Gain</p>
              <h4>{overallData.currency + " " + overallData.gain}</h4>
            </div>
            <div>
              <p>Adviced Gainper</p>
              <p>
                {overallData.gainper > 0 ? (
                  <h4>
                    {overallData.gainper + "%"}{" "}
                    <img src={Upd} style={{ verticalAlign: "middle" }} />{" "}
                  </h4>
                ) : overallData.gainper < 0 ? (
                  <h4>
                    {overallData.gainper + "%"}{" "}
                    <img src={Down} style={{ verticalAlign: "middle" }} />{" "}
                  </h4>
                ) : overallData.gainper == 0 ? (
                  <h4>{overallData.gainper + "%"} </h4>
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>

          <div style={{ display: "flex", columnGap: 30, flexWrap: "wrap" }}>
            <div>
              <p>Total Invested Amount</p>
              <h4>
                {overallData.currency + " " + overallData.invested_invamt}
              </h4>
            </div>
            <div>
              <p>Invested Current Value</p>
              <h4>
                {overallData.currency + " " + overallData.invested_curval}
              </h4>
            </div>
            <div>
              <p>Invested Gain</p>
              <h4>{overallData.currency + " " + overallData.invested_gain}</h4>
            </div>
            <div>
              <p>Invested Gainper</p>
              <p>
                {overallData.invested_gainper > 0 ? (
                  <h4>
                    {overallData.invested_gainper + "%"}{" "}
                    <img src={Upd} style={{ verticalAlign: "middle" }} />{" "}
                  </h4>
                ) : overallData.invested_gainper < 0 ? (
                  <h4>
                    {overallData.invested_gainper + "%"}{" "}
                    <img src={Down} style={{ verticalAlign: "middle" }} />{" "}
                  </h4>
                ) : overallData.invested_gainper == 0 ? (
                  <h4>{overallData.invested_gainper + "%"} </h4>
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell rowspan="2">Country</TableCell>

            <TableCell rowspan="2">Name</TableCell>

            <TableCell rowspan="2">Type</TableCell>

            <TableCell colspan="4" style={{ textAlign: "center" }}>
              Adviced
              <TableCell style={{ textAlign: "left" }}>Amount</TableCell>
              <TableCell style={{ textAlign: "left" }}>Weightage</TableCell>
              <TableCell style={{ textAlign: "left" }}>Current value</TableCell>
              <TableCell style={{ textAlign: "left" }}>Change(%)</TableCell>
            </TableCell>

            <TableCell colspan="4" style={{ textAlign: "center" }}>
              Invested
              <TableCell>Amount</TableCell>
              <TableCell style={{ textAlign: "left" }}>Weightage</TableCell>
              <TableCell>Current value</TableCell>
              <TableCell>Change(%)</TableCell>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((rows) => {
            return (
              <TableRow>
                {columns.map((cols) => {
                  const value = rows[cols.id];
                  return (
                    <TableCell
                      onClick={(e) => showCumulative(e, rows)}
                      style={{ cursor: cols.cursor }}
                    >
                      {cols.label === "Country" ? (
                        <img src={`https://flagcdn.com/16x12/${value}.png`} />
                      ) : cols.align === "center" &&
                        cols.type === "percentage" ? (
                        <p>{value + "%"}</p>
                      ) : cols.type === "weight_percentage" ? (
                        <p style={{ textAlign: "center" }}>{value + "%"}</p>
                      ) : cols.align === "center" ? (
                        <p style={{ textAlign: "center" }}>
                          {rows.currency + value}
                        </p>
                      ) : (
                        value
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {popUp ? (
        <div>
          {data.type !== "Mutual Funds" ? (
            <div
              style={{
                display: close ? "none" : "block",
                background: "rgb(0, 0, 0, 0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  width: "30%",
                  borderRadius: 20,
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%",
                  padding: "15px 10px 15px 20px",
                }}
              >
                <div style={{ textAlign: "right" }}>
                  <CancelIcon
                    onClick={closePop}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div style={{ overflow: "auto", height: 360 }}>
                  <>
                    {data.type !== "Mutual Funds" &&
                      data.cummilative.map((item1) => {
                        return (
                          <div>
                            <div>
                              <h2
                                style={{
                                  color: "#2835d5",
                                  fontSize: 20,
                                  marginBottom: 0,
                                  paddingBottom: 0,
                                }}
                              >
                                {item1.name}
                              </h2>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <h3
                                style={{ color: "#08054e", fontWeight: "bold" }}
                              >
                                {data.name}
                              </h3>
                              <p>
                                <span
                                  style={{
                                    color: "#08054e",
                                    marginRight: 10,
                                    fontWeight: 500,
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                  }}
                                >
                                  {data.currency + item1.gain}
                                </span>{" "}
                                {/* <span>{item1.gainper}</span> */}
                                <span>
                                  {item1.gainper > 0 ? (
                                    <sapn
                                      style={{
                                        color: "#11be74",
                                        fontWeight: "bold",
                                        fontSize: "18px",
                                      }}
                                    >
                                      {item1.gainper}{" "}
                                      <img
                                        src={Upd}
                                        style={{ verticalAlign: "middle" }}
                                      />
                                    </sapn>
                                  ) : (
                                    <span style={{ color: "#ff9505" }}>
                                      {item1.gainper}{" "}
                                      <img
                                        src={Down}
                                        style={{ verticalAlign: "middle" }}
                                      />
                                    </span>
                                  )}
                                </span>
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                backgroundColor: "#e0e7f7",
                                padding: "0px 15px",
                                marginRight: "5px",
                                borderRadius: "7px",
                                marginBottom: 0,
                                color: "#8b94b4",
                              }}
                            >
                              <p>
                                <p>{data.currency + " " + data.advisedval}</p>
                                <p>Advised Value</p>
                              </p>

                              <p>
                                <p>{data.currency + " " + item1.investedval}</p>
                                <p>Invested Value</p>
                              </p>
                            </div>

                            <div
                              className="col2"
                              style={{
                                margin: "0 auto",
                                display: "flex",
                                columnGap: 20,
                              }}
                            >
                              <div id="div1">
                                <h5>{data.currency + " " + item1.avgamt}</h5>
                                <p>Average Cost</p>
                              </div>

                              <div
                                className="mul"
                                style={{ marginTop: 20, marginRight: 15 }}
                              >
                                {" "}
                                x{" "}
                              </div>

                              <div id="div2">
                                <h5>{item1.qty}</h5>
                                <p>Quantity</p>
                              </div>

                              <div
                                className="mul"
                                style={{ marginTop: 20, marginRight: 15 }}
                              >
                                {" "}
                                ={" "}
                              </div>

                              <div id="div3">
                                <h5>
                                  {data.currency + " " + item1.investedval}
                                </h5>
                                <p>Invested Value</p>
                              </div>
                            </div>

                            <div
                              className="col2"
                              style={{
                                margin: "0px auto 0 auto",
                                display: "flex",
                                columnGap: 20,
                              }}
                            >
                              <div id="div1">
                                <h5>
                                  {data.currency + " " + item1.shareprice}
                                </h5>
                                <p>Share Price</p>
                              </div>

                              <div
                                className="mul"
                                style={{ marginTop: 20, marginRight: 15 }}
                              >
                                {" "}
                                x{" "}
                              </div>

                              <div id="div2">
                                <h5>{item1.qty}</h5>
                                <p>Quantity</p>
                              </div>

                              <div
                                className="mul"
                                style={{ marginTop: 20, marginRight: 15 }}
                              >
                                {" "}
                                ={" "}
                              </div>

                              <div id="div3">
                                <h5>
                                  {data.currency + " " + item1.currentval}
                                </h5>
                                <p>Current Value</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </>
                </div>
                <p id="Note">
                  Note: All display data is as of the last closing (EOD) market
                  day.
                </p>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: close ? "none" : "block",
                background: "rgb(0, 0, 0, 0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  width: "30%",
                  borderRadius: 20,
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%",
                  padding: "15px 10px 15px 25px",
                }}
              >
                <div style={{ textAlign: "right" }}>
                  <CancelIcon
                    onClick={closePop}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div
                  className="col1"
                  style={{ display: "flex", columnGap: 30 }}
                >
                  <div id="div1">
                    <h5>{data.invested_purchaseNAV}</h5>

                    <p>Purchase NAV</p>
                  </div>

                  <div id="div2">
                    <h5>{data.currency + " " + data.investedval}</h5>
                    <p>Invested Value</p>
                  </div>
                </div>

                <div
                  className="col2"
                  style={{ display: "flex", columnGap: 30 }}
                >
                  <div id="div1">
                    <h5>{data.invested_currentNAV}</h5>
                    <p>Current NAV</p>
                  </div>

                  <div id="div2">
                    <h5>{data.currency + " " + data.invested_currentval}</h5>
                    <p>Current Value</p>
                  </div>
                </div>
                <p id="Note">
                  Note: All display data is as of the last closing (EOD) market
                  day.
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {filter ? (
        <Portfoliofilter
          id={myparam.state.customer_id}
          getDelivedState={getDelivedState}
        />
      ) : (
        ""
      )}
    </div>
  );
}

function Portfoliofilter(props) {
  // const userDetails = JSON.parse(localStorage.getItem("savartuser"));
  // const { token } = userDetails;

  // const authDetails = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  const [labelData, setlabelData] = useState([]);

  const [defaultCheck, setDefaultCheck] = useState(false);

  useEffect(() => {
    getportfolioFIlters();

    // props.state=state'
  }, [defaultCheck]);

  const [state, setState] = useState("abcdefg");
  // (state);

  // window.myvar = state;

  // (window.myvar, "window.myvar");

  var emptyObj = {};

  const handleChange = (
    event,
    index,
    name,
    status,
    getvalue,
    obj,
    label,
    keyname,
    keyname2
  ) => {
    setDefaultCheck(true);
    // (keyname2,"keyname2");
    // (getvalue,"getvalue");

    if (event.target.value === "All" && event.target.checked === true) {
      for (var i = 0; i < obj.values.length; i++) {
        document.getElementById(
          obj.values[i]["value"] + obj.values[i]["key_name"]
        ).checked = true;
      }
    } else if (event.target.value === "All" && event.target.checked === false) {
      alert("please select atleast one option");
      document.getElementById(
        obj.values[0]["value"] + obj.values[0]["key_name"]
      ).checked = false;
      for (var i = 0; i < obj.values.length; i++) {
        document.getElementById(
          obj.values[i]["value"] + obj.values[i]["key_name"]
        ).checked = true;
        // document.getElementById(obj.values[i]['value'] + obj.values[i]['key_name']).checked = false;
      }
    } else {
      document.getElementById(
        obj.values[0]["value"] + obj.values[0]["key_name"]
      ).checked = false;

      if (
        document.querySelectorAll("input[name=" + keyname2 + "]:checked")
          .length ===
        obj.values.length - 1
      ) {
        document.getElementById(
          obj.values[0]["value"] + obj.values[0]["key_name"]
        ).checked = true;
      } else if (
        document.querySelectorAll("input[name=" + keyname2 + "]:checked")
          .length == 0
      ) {
        document.getElementById(getvalue + keyname).checked = true;
        alert("select atleast one option");
        //   for (var i = 0; i < obj.values.length; i++) {
        //     document.getElementById(obj.values[i]['value'] + obj.values[i]['key_name']).checked = true;
        // }
      }
    }

    var checked_data = document.querySelectorAll(
      "input[name=" + keyname2 + "]:checked"
    );
    var temp = [];
    for (var checkbox of checked_data) {
      temp.push(checkbox.value);
    }
    emptyObj[keyname2] = temp;
    localStorage.setItem("portfolio_filter", JSON.stringify(emptyObj));
  };

  const getportfolioFIlters = async () => {
    http
      .get(`/investments?cust_id=` + props.id)
      .then((res) => {
        setlabelData(res.data.filter_data);
      })
      .catch((err) => {});
  };

  const clearFilter = (e) => {
    var checked_boxes = document.querySelectorAll("input[type='checkbox']");
    for (var i = 0; i < checked_boxes.length; i++) {
      checked_boxes[i].checked = true;
    }
  };

  const [setClose, getClose] = useState(false);

  const apply = (e) => {
    var str = "";
    for (var i = 0; i < labelData.length; i++) {
      if (
        document.querySelectorAll(
          "input[name=" + labelData[i]["key_name"] + "]:checked"
        ).length === labelData[i]["values"].length
      ) {
        if (str) {
          str += "&" + labelData[i]["key_name"] + "=All";
        } else {
          str += labelData[i]["key_name"] + "=All";
        }
      } else {
        var temp_val = "";
        var checked_values = document.querySelectorAll(
          "input[name=" + labelData[i]["key_name"] + "]:checked"
        );
        // (document.quer,'checked_values');
        for (var j = 0; j < checked_values.length; j++) {
          if (temp_val) {
            temp_val += "," + checked_values[j].value;
          } else {
            temp_val += checked_values[j].value;
          }
        }
        if (str) {
          str += "&" + labelData[i]["key_name"] + "=" + temp_val;
        } else {
          str += labelData[i]["key_name"] + "=" + temp_val;
        }
      }
    }
    setState(str);
    props.getDelivedState(str);
    // localStorage.removeItem('filterstr');
    localStorage.setItem("filterstr", str);
    getClose(true);
  };

  const close = (e) => {
    e.preventDefault();
    getClose(true);
  };

  return (
    <div className="bg" style={{ display: setClose ? "none" : "block" }}>
      <div className="filter_parent">
        <div>
          <p style={{ textAlign: "right" }}>
            <CloseIcon onClick={close} style={{ cursor: "pointer" }} />
          </p>
        </div>
        <div>
          {/* <h1 style={{fontSize:'25px'}}>Filter <span  ><button onClick={clearFilter} style={{display:'inline-block', color:'#2835d5',textDecoration:'underline', fontSize:'18px', marginLeft:'30px',cursor:'pointer', backgroundColor:'transparent'}}>         
         Clear All
         </button></span></h1> */}

          <h1 style={{ fontSize: "25px" }}>
            Filter{" "}
            {defaultCheck ? (
              <span>
                <button
                  onClick={clearFilter}
                  style={{
                    display: "inline-block",
                    color: "#2835d5",
                    textDecoration: "underline",
                    fontSize: "18px",
                    marginLeft: "30px",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    border: "2px solid transparent",
                  }}
                >
                  Set Default
                </button>
              </span>
            ) : (
              ""
            )}
          </h1>
        </div>
        {labelData.map((item, index) => {
          return (
            <>
              <div className="filter_sub_parent">
                <div className="filter_left">
                  <h2>{item.label}</h2>
                </div>
                <div className="filter_right_parent">
                  {item.values.map((item2, index) => {
                    var loc_port_filt =
                      localStorage.getItem("portfolio_filter");
                    if (loc_port_filt) {
                      loc_port_filt = JSON.parse(loc_port_filt);
                    }
                    var defaultChecked = true;
                    if (loc_port_filt && item.key_name in loc_port_filt) {
                      if (
                        loc_port_filt[item.key_name].includes(
                          item2.value.toString()
                        )
                      ) {
                        defaultChecked = true;
                      } else {
                        defaultChecked = false;
                      }
                    } else {
                      defaultChecked = true;
                    }
                    return (
                      <div className="filter_right">
                        <div>
                          <p>
                            <input
                              type="checkbox"
                              name={item.key_name}
                              id={item2.value + item2.key_name}
                              value={item2.value}
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  index,
                                  item2.name,
                                  item2.status,
                                  item2.value,
                                  item,
                                  item.label,
                                  item2.key_name,
                                  item.key_name
                                )
                              }
                              defaultChecked={defaultChecked}
                            />
                            <label for={item2.value + item2.key_name}>
                              {item2.name}
                            </label>
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          );
        })}
        <button
          style={{
            display: "block",
            margin: "30px auto 10px auto",
            backgroundColor: "#2835d5",
            color: "#fff",
            padding: "10px 40px",
            fontSize: "18px",
            borderRadius: "30px",
            cursor: "pointer",
          }}
          onClick={apply}
        >
          Apply
        </button>
      </div>
    </div>
  );
}
